import React, { Fragment } from 'react';

import walking13 from '../../../../../images/walking13.jpg';
import walking15 from '../../../../../images/walking15.jpg';

const SkyportEnter = () => (
  <Fragment>
    <div>
      <img
        className="faq-image-compress"
        src={walking13}
        alt="Parking Lot"
      />
      <p>
        All Autzu vehicles have a parking access card. Use this card to
        enter and exit the parking lot when driving an Autzu vehicle.
        <br />
        <br />
        <b>
          Note:The parking card must remain safely inside the vehicle at
          all times.
        </b>
      </p>
    </div>
    <div>
      <img
        className="faq-image-compress"
        src={walking15}
        alt="Parking Lot"
      />
      <p>
        Tap the card parking card on the receiver and the parking gate will
        open upon entry and exit.
      </p>
    </div>
  </Fragment>
);

export default SkyportEnter;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/ParkingLotData/Skyport/SkyportEnter.js